<template>
  <div id="ml">
    <div class="ui piled segment" style="padding: 30px">
    <h4 class="ui header">MENTIONS LÉGALES</h4>

    <div class="ml_author">
      Responsable de la publication – Nathalie <span style="font-weight: bold">BENOUAICH</span>
    </div>
    <br><br>

      <span style="font-weight: bold; color: #0cb4c1">CPMS SAS</span> – Société de Gestion et de Courtage d’Assurance au capital

      de 2 729 468 € inscrite auprès de l’ORIAS sous le N° 07 001 007

      4, Rue Auber Marie 75009 PARIS

      Téléphone : 01 47 70 30 97 – Fax : 01 42 46 68 10 – www.cpms.fr

      RC PARIS B 97 B 14894 – Siret 414 357 889 00040

      Garantie Financière et RC Professionnelle conformes aux articles L 530-1 et 530-2 du Code des Assurances.


      <div class="ml_title">
        AVERTISSEMENT:
      </div>

      Les informations présentées sur ce site sont nécessairement partielles et n’ont aucune valeur contractuelle.



      <div class="ml_title">
        DROIT APPLICABLE:
      </div>

      Le présent site est soumis au droit français.



      <div class="ml_title">
        REPRODUCTION INTERDITE:
      </div>

      Sauf autorisation, la reproduction ainsi que l’utilisation du contenu du site autre que la consultation individuelle et privée sont interdites.


      <div class="ml_title">
        PROTECTION DES DONNÉES:
      </div>
      <p>
        Conformément à la loi Informatique et Libertés du 6 janvier 1978 et du règlement général sur la protection des données (RGPD) en date du 27 Avril 2016, les données personnelles recueillies dans le cadre du présent contrat feront l’objet d’un traitement informatique nécessaire à la gestion et l’exécution de votre contrat santé. En signant ce document, vous donnez expressément votre consentement au traitement de vos données personnelles. Aucun traitement commercial ne sera mise en œuvre. En l’application de la législation en vigueur, vous pourrez exercer votre droit d’accès, de rectification et d’opposition concernant l’utilisation et le traitement de vos données personnelles en écrivant par voie postale ou par email au délégué à la protection des données : dpo@cpms.fr / CPMS-DPO 4 Rue Auber, 75009 Paris.
      </p>

  </div>
  </div>
</template>

<style media="screen">
  div#ml {
    width: 700px;
    margin: auto;
    padding-top: 100px;
  }
  .ml_author {
    color: #636363;
  }
  .ml_title {
    color: #0cb4c1;
    margin-top: 20px;
  }
  div#ml p {
    text-align: justify;
  }
</style>
